var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.8 19.8",
    style: {
      enableBackground: "new 0 0 19.8 19.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\r\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#C8C8C8;stroke-width:1.1974;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.2,11.1V8.6h-2.6c-0.2-0.9-0.5-1.8-1.1-2.6l1.8-1.8l-1.7-1.7l-1.8,1.8c-0.8-0.5-1.6-0.9-2.6-1.1V0.6H8.7v2.6 C7.7,3.4,6.8,3.8,6.1,4.3L4.2,2.5L2.5,4.2l1.8,1.8C3.8,6.8,3.4,7.7,3.3,8.6H0.7v2.5h2.6c0.2,0.9,0.5,1.8,1.1,2.6l-1.8,1.8l1.7,1.7 l1.8-1.8c0.8,0.5,1.6,0.9,2.6,1.1v2.6h2.5v-2.6c0.9-0.2,1.8-0.5,2.6-1.1l1.8,1.8l1.7-1.7l-1.8-1.8c0.5-0.8,0.9-1.6,1.1-2.6H19.2z  M9.9,13.1c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2C13.1,11.6,11.7,13.1,9.9,13.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSystem);
export default __webpack_public_path__ + "static/media/nav_system.a734c2c622c4d5dc70a845ed586e2f41.svg";
export { ForwardRef as ReactComponent };